import { http } from '@/support/http/http'

const login = ({ commit }, user) => {
  return new Promise((resolve, reject) => {
    commit('authRequest')
    http.post('authenticate', user)
      .then(resp => {
        const token = resp.data.token
        const user = resp.data.infos
        const data = decryptToken(token)
        window.localStorage.setItem('token', token)
        window.localStorage.setItem('data_travessia_webapp', data)
        window.localStorage.setItem('user', JSON.stringify(user))
        http.defaults.headers.common.Authorization = token
        commit('authSuccess', token, user)
        resolve(resp)
      })
      .catch(err => {
        commit('authError')
        localStorage.removeItem('token')
        reject(err)
      })
  })
}
const logout = ({ commit }, $router) => {
  commit('logout')
  window.localStorage.clear()
  $router.push({ path: '/' })
}
const decryptToken = (token) => {
  const tokenSplit = token.split('.')
  const data = JSON.stringify(JSON.parse(atob(tokenSplit[1])).data)
  return data
}
export default {
  login,
  logout
}
